import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useControlled } from '@costar-ui/hooks';
import React__default, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { getStarValues } from './get-star-values.esm.js';
import { StarRatingBase } from './star-rating-base.esm.js';
import HoverSlot from '../../layout/slot/hover-slot.esm.js';
import Tooltip from '../../tooltip/tooltip.esm.js';
import TooltipContentDefault from '../../tooltip/tooltip-content-default.esm.js';
import Slot from '../../layout/slot/slot.esm.js';

var _excluded = ["onClick", "value", "tooltipContent"];
var maxRating = 5; //is it worth supporting anything else? no?
var defaultRating = 0;
var StarRatingFilter = function StarRatingFilter(props) {
  var _tooltipContent$link2;
  var onClick = props.onClick,
    value = props.value,
    tooltipContent = props.tooltipContent,
    rest = _objectWithoutProperties(props, _excluded);
  var _useControlled = useControlled({
      controlled: value !== null && value !== void 0 ? value : undefined,
      //pass 0 or [] if you want controlled
      "default": defaultRating,
      name: 'Rating',
      state: 'open'
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    rateState = _useControlled2[0],
    setRatingState = _useControlled2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTooltipOpen = _useState2[0],
    setTooltipOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHovered = _useState4[0],
    setIsHovered = _useState4[1];
  var hoverTimeoutRef = useRef(null);
  var animationFrameRef = useRef(null);
  var _useState5 = useState(getStarValues(rateState, maxRating)),
    _useState6 = _slicedToArray(_useState5, 2),
    starValues = _useState6[0],
    setStarValues = _useState6[1];
  useEffect(function () {
    setStarValues(getStarValues(rateState, maxRating));
  }, [rateState]);
  var setHandleStarClick = useCallback(function (index) {
    return function () {
      if (animationFrameRef.current !== null) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      animationFrameRef.current = requestAnimationFrame(function () {
        var nextRating = Array.isArray(rateState) ? rateState.includes(index + 1) ? rateState.filter(function (i) {
          return i !== index + 1;
        }) : [].concat(_toConsumableArray(rateState), [index + 1]).sort(function (a, b) {
          return a - b;
        }) : index + 1;
        setRatingState(nextRating);
        onClick && onClick(nextRating);
        if (!isTooltipOpen) {
          setTooltipOpen(true);
        }
        animationFrameRef.current = null;
      });
    };
  }, [onClick, rateState, setRatingState, isTooltipOpen]);
  useEffect(function () {
    return function () {
      if (animationFrameRef.current !== null) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);
  var handleMouseEnter = useCallback(function () {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setIsHovered(true);
  }, []);
  var handleMouseLeave = useCallback(function () {
    hoverTimeoutRef.current = setTimeout(function () {
      setIsHovered(false);
    }, 200);
  }, []);
  var starRatingBase = useMemo(function () {
    return /*#__PURE__*/React__default.createElement(StarRatingBase, _extends({
      valueArray: starValues,
      onClick: setHandleStarClick
    }, rest));
  }, [rest, setHandleStarClick, starValues]);
  var starRatingAnchor = useMemo(function () {
    return /*#__PURE__*/React__default.createElement(HoverSlot, {
      className: "pl-0.5",
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, starRatingBase);
  }, [handleMouseEnter, handleMouseLeave, starRatingBase]);
  var tooltipContentLink = useMemo(function () {
    var _tooltipContent$link;
    return {
      label: (tooltipContent === null || tooltipContent === void 0 || (_tooltipContent$link = tooltipContent.link) === null || _tooltipContent$link === void 0 ? void 0 : _tooltipContent$link.label) || '',
      href: 'https://www.buildingratingsystem.com/'
    };
  }, [tooltipContent === null || tooltipContent === void 0 || (_tooltipContent$link2 = tooltipContent.link) === null || _tooltipContent$link2 === void 0 ? void 0 : _tooltipContent$link2.label]);
  return tooltipContent ? /*#__PURE__*/React__default.createElement(Tooltip, {
    isOpen: isHovered,
    anchorElement: starRatingAnchor,
    maxWidth: 300,
    placement: "bottom",
    offset: 10
  }, /*#__PURE__*/React__default.createElement(Slot, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React__default.createElement(TooltipContentDefault, {
    heading: tooltipContent.heading,
    text: tooltipContent.text,
    link: tooltipContentLink
  }))) : starRatingBase;
};

export { StarRatingFilter };
//# sourceMappingURL=star-rating-filter.esm.js.map
